export const siteSettings = {
  name: "Capital Cent",
  link: "https://capitalcentpro.live",
  email: "support@capitalcentpro.live",
  appLink: "https://app.capitalcentpro.live",
};
